import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    redirect: "/homePage",
    meta: {
      requireAuth: true,
      keepAlive: false,
      title: "",
    },
  },
  {
    path: "/homePage",
    name: "homePage",
    component: () => import("../views/HomeView.vue"),
    meta: {
      requireAuth: true,
      keepAlive: false,
      title: "",
    },
  },
  {
    path: "/introduce",
    name: "introduce",
    component: () => import("../views/introduce.vue"),
    meta: {
      requireAuth: true,
      keepAlive: false,
      title: "",
    },
  },
  {
    path: "/confide",
    name: "confide",
    component: () => import("../views/confide.vue"),
    meta: {
      requireAuth: true,
      keepAlive: false,
      title: "",
    },
  },
  {
    path: "/listener",
    name: "listener",
    component: () => import("../views/listener.vue"),
    meta: {
      requireAuth: true,
      keepAlive: false,
      title: "",
    },
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});
// 解决重复点击导航时，控制台出现报错
const VueRouterPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(to) {
  return VueRouterPush.call(this, to).catch((err) => err);
};
router.afterEach(() => {
  window.scrollTo(0, 0); // 滚动到顶部
});
export default router;
